<template>
  <el-select
    ref="selectAbc"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
  import {getDictList} from '@/utils/getDictDataList.js'
  export default {
    name: "ct-select",
    props: {
      codeType: String,
    },
    data(){
      return {
        options: []
      }

    },

    async created() {
      this.options = getDictList(this.codeType)
      if (this.options === undefined || this.options === null ||this.options.length === 0) {
        let optionsName = ""
        if (!this.codeType) {
          optionsName = "当前type值为空"
        } else {
          optionsName = this.codeType + "类型不存在"
        }
        this.options = [
          {
            value: "0",
            label: optionsName
          }
        ]
        const _this = this
        await this.$nextTick();
        // console.log("select",this.$refs.selectAbc.value)
        const ab = {
          value: this.$refs.selectAbc.value,
          label: '当前值没有对应的label'
        }
        this.options.push(ab)
      
      }
      else {
        // console.log("21",this.options)
        //根据value值进行排序
        this.options.sort((a, b)=>{
          return a.value - b.value
        })
        // console.log("21",this.options)
      }

    
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
